import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import Skeleton from "../../components/Skeleton/Skeleton";
import ContentAccordion from "../../components/ContentAccordion/ContentAccordion";
import store from "../../store";
import {Helmet} from "react-helmet";

const rates = () => {
    return (
            <div className="wrapper mbl pbs">
                <Helmet>
                    {
                        store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                            return row.rowTitle === "Ship" ? row.sections.map((section) => {
                                return section.title === "Rates" ? <meta name="description" content={section.content['seo-description']}/> : null
                            }) : null
                        }) : null
                    }
                </Helmet>
                <Breadcrumbs/>
                <ContentPanel
                        skeleton={<Skeleton type="MAIN_PANEL"/>}
                        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                        templateUrl="./content/ship/page-components/text-block/rates-heading.html"
                />
                <div className="mbl pbm">
                    <ContentAccordion
                            jsonDataUrl="./content/ship/page-components/accordion/rates.json"
                    />
                </div>
                <ContentPanel
                        skeleton={<Skeleton type="MAIN_PANEL"/>}
                        errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
                        templateUrl="./content/ship/page-components/text-block/rates-body-1.html"
                />
            </div>
    )
};

export default rates;



// WEBPACK FOOTER //
// ./src/pages/ship/Rates.js